import gql from 'graphql-tag'

const clientiById = gql`
  query clienti (
    $id: Int!
  ) {
    clienti (
      limit: 1
      offset: 0
      where: { id: $id }
    ) {
      totalCount
      nodes {
        id
        nome
        email
        telefono
      }
    }
  }
`

export default clientiById


// WEBPACK FOOTER //
// ./src/graphql/queries/clientiById.js